/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setUser } from "../states/user/userSlice";
import customerServices from "../services/CustomerService";
import { Modal } from "antd";
import Navbar from "../pages/common/Navbar";
import Footer from "../pages/common/Footer";
import { LayoutDashboard, CreditCard, FileText, Settings } from "lucide-react";
const DashboardLayout = (props) => {
  const { confirm } = Modal;
  const dispatch = useDispatch();
  const { navigation, children } = props;
  const [iconStyle, setIconStyle] = useState(true);
  const user = useSelector((state) => state.user);
  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    navigate("/login");
  };
  useEffect(() => {
    customerServices
      .GetUser()
      .then((response) => {
        if (response.status) {
          dispatch(setUser(response.resultData));
        }
      })
      .catch((error) => {
        console.log(error);
      });
    setIconStyle(false);
  }, []);
  return (
    <>
      <div className="dashboard">
        <Navbar />
        <aside className="main-sidebar sidebar-light-primary elevation-4 ">
          {/* Brand Logo */}
          <a className="brand-link d-flex align-items-center justify-content-center py-2 second-img"></a>
          <div className="sidebar">
            <nav className="mt-5">
              <ul
                className="nav nav-pills nav-sidebar flex-column"
                data-widget="treeview"
                role="menu"
                data-accordion="false"
              >
                <li className="nav-item my-1">
                  <Link
                    to="/dashboard"
                    className={`nav-link ${
                      navigation === "dashboard" ? "active" : ""
                    } `}
                  >
                    {/* <i className="nav-icon fa-solid fa-gauge "></i> */}
                    <LayoutDashboard
                      className="nav-icon me-2"
                      size={20}
                      style={{ color: "#fff" }}
                    />
                    <p>Dashboard</p>
                  </Link>
                </li>
                <li className="nav-item my-1">
                  <Link
                    to="/signed-agreements"
                    className={`nav-link ${navigation === "signed-agreements" ? "active" : ""} `}
                  >
                    <FileText
                      className="nav-icon me-2"
                      size={20}
                      style={{ color: "#fff" }}
                    />
                    <p>Agreements</p>
                  </Link>
                </li>
                <li className="nav-item my-1">
                  <Link
                    to="/paymenthistory"
                    className={`nav-link ${navigation === "paymenthistory" ? "active" : ""} `}
                  >
                    <CreditCard
                      className="nav-icon me-2"
                      size={20}
                      style={{ color: "#fff" }}
                    />
                    <p>Payment History</p>
                  </Link>
                </li>
                {/* <li className="nav-item my-1">
                <Link
                  to="/agreement"
                  className={`nav-link ${
                    navigation === "agreement" ? "active" : ""
                  } `}
                >
                  <p>Agreements</p>
                </Link>
              </li> */}
              </ul>
            </nav>
          </div>
        </aside>
        {children}
        <aside className="control-sidebar control-sidebar-dark"></aside>
      </div>
      <Footer />
    </>
  );
};

export default DashboardLayout;
